// "Copy" for any of VERA's answers: the text goes to the clipboard, ready to paste into an email, a document or a form.
import { useState } from "react";
import { Icon, useStudio } from "./ui";
import { L } from "../lib/i18n";

export function CopyButton({ text }: { text: string }) {
  const { toast } = useStudio();
  const [done, setDone] = useState(false);
  async function copy() {
    try { await navigator.clipboard.writeText(text); setDone(true); setTimeout(() => setDone(false), 1800); }
    catch { toast(L("Couldn't copy. Select the text and press Ctrl+C.", "Nuk u kopjua. Zgjidh tekstin dhe shtyp Ctrl+C.")); }
  }
  return (
    <button type="button" className="linkbtn readaloud" onClick={() => void copy()} title={L("Copy", "Kopjo")}>
      <Icon name={done ? "check" : "doc"} size={13} /> {done ? L("Copied", "U kopjua") : L("Copy", "Kopjo")}
    </button>
  );
}
